import { patchRequest } from "../../globalhelper/helper";
import store from "../../store";
import {
  FLUSH_COMMON_OBJECT,
  FLUSH_MENU_TREE,
  GET_CURRENT_MENU_TREE,
  HIDE_ALERT,
  HIDE_LOADER,
  INITIATE_COMMON,
  NAVURL,
  SET_MENU_TREE,
  SHOW_ALERT,
  SHOW_LOADER,
  UPDATE_USER_CONFIGURATION,
  SET_ORGANIZATIONS,
  SET_USER_TYPE,
} from "./commonActionTypes";

export function showLoader() {
  return (dispatch) => {
    dispatch({ type: SHOW_LOADER });
  };
}

export function hideLoader() {
  console.log(HIDE_LOADER);

  return (dispatch) => {
    dispatch({ type: HIDE_LOADER });
  };
}

export function showAlert(msg, status) {
  return (dispatch) => {
    dispatch({
      type: SHOW_ALERT,
      text: msg,
      status,
    });
  };
}

export function hideAlert() {
  return (dispatch) => {
    dispatch({
      type: HIDE_ALERT,
    });
  };
}

export function flushCommonObject() {
  return (dispatch) => {
    dispatch({
      type: FLUSH_COMMON_OBJECT,
    });
  };
}

export function flushMenuTree() {
  return (dispatch) => {
    dispatch({
      type: FLUSH_MENU_TREE,
    });
  };
}

export function getCurrentMenuTree() {
  return (dispatch) => {
    dispatch({
      type: GET_CURRENT_MENU_TREE,
    });
  };
}

export function setMenuTree(menuTree) {
  return (dispatch) => {
    dispatch(flushMenuTree());
    dispatch({
      type: SET_MENU_TREE,
      menuTree,
    });
  };
}

export function navUrl(url, pagename = null) {
  return (dispatch) => {
    dispatch({
      type: NAVURL,
      url,
      pagename,
    });
  };
}

export function initiateCommon(data) {
  return (dispatch) => {
    dispatch({
      type: INITIATE_COMMON,
      data,
    });
  };
}

export function navigateToModule(module) {
  return (dispatch) => {
    const state = store.getState();
    let LANDING_PAGE = null;
    if (module.shortkey === "OneRetail") {
      LANDING_PAGE = "/26AS_dashboard";
    } else if (module.shortkey === "PMA") {
      LANDING_PAGE = "/uploadv2";
    } else if (state.login.userData.USR_Tenant === "FM00001") {
      LANDING_PAGE = "/schemaNew";
    } else {
      LANDING_PAGE = "/dashboard";
    }

    sessionStorage.setItem("menuTree", null);
    dispatch(flushMenuTree());
    localStorage.setItem("module", module?.shortkey);
    sessionStorage.setItem("module_desc", module?.desc || module.name);
    sessionStorage.setItem("module_desc_for_ui_only", "");
    sessionStorage.setItem("pageName", "");
    sessionStorage.setItem("system", module?.system);

    if (state.login.userData.landing_page_url) {
      let L_PAGE = state.login.userData.landing_page_url;
      if (L_PAGE) {
        L_PAGE =
          (L_PAGE.charAt(0) === "/" ? "/" : "/" + L_PAGE.charAt(0)) +
          L_PAGE.slice(1);
      }
      dispatch(navUrl(L_PAGE));
    } else {
      dispatch(navUrl(LANDING_PAGE));
    }
  };
}

export function updateUserConfiguration(configuration) {
  return (dispatch) => {
    const email = store.getState()?.login?.userData?.USR_Email;
    patchRequest("api/user/userConfiguration", { email, configuration })
      .then((response) => {
        dispatch({ type: UPDATE_USER_CONFIGURATION, data: response.res.data });
      })
      .catch(() => {
        dispatch({ type: UPDATE_USER_CONFIGURATION, data: {} });
      });
  };
}

export function setOrganizations(organizations) {
  return (dispatch) => {
    dispatch({
      type: SET_ORGANIZATIONS,
      organizations,
    });
  };
}

export function setUserType(userType) {
  return (dispatch) => {
    dispatch({
      type: SET_USER_TYPE,
      userType,
    });
  };
}